import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
//Components
import { Input, translateMessage } from "@delibrandev/utils";
import { Button } from "@delibrandev/utils";
//Styles
import "./style.css";
import "./responsive.css";
//Assets
import { sendCustomerVerificationCode, verifyCode } from "../../api/login";
import { setAlert } from "../../reducers/userConfigSlice";

export const VerifyPhone = () => {
  const dispatch = useDispatch();
  const logged = useSelector((state) => state.aplicationConfig.userConfig.logged);
  const navigate = useNavigate();
  const [mode, setMode] = useState("phone");

  const sendCode = async () => {
    const response = await sendCustomerVerificationCode({});
    console.log(response);
    if (response && !response?.error) {
      dispatch(setAlert(translateMessage(response?.message || "Bad request")));
    } else {
      dispatch(setAlert(translateMessage(response?.message || "Bad request")));
    }
    setMode("code");
  };

  const getClipboardText = async () => {
    try {
      if (!navigator.clipboard) {
        throw new Error("Clipboard API no está disponible en este navegador.");
      }
      const text = await navigator.clipboard.readText();
      const isSixDigitNumber = (value) => {
        const regex = /^\d{6}$/;
        return regex.test(value);
      };

      if (isSixDigitNumber(text)) {
        document.getElementById("code_1").value = text[0];
        document.getElementById("code_2").value = text[1];
        document.getElementById("code_3").value = text[2];
        document.getElementById("code_4").value = text[3];
        document.getElementById("code_5").value = text[4];
        document.getElementById("code_6").value = text[5];
      } else {
        document.getElementById("code_1").value = "";
        document.getElementById("code_2").value = "";
        document.getElementById("code_3").value = "";
        document.getElementById("code_4").value = "";
        document.getElementById("code_5").value = "";
        document.getElementById("code_6").value = "";
      }
    } catch (error) {
      console.error("Error al obtener el texto del portapapeles:", error);
      return null;
    }
  };

  const CodeArea = () => {
    const verifyPhone = async () => {
      const payload = {
        code:
          document.getElementById("code_1").value +
          document.getElementById("code_2").value +
          document.getElementById("code_3").value +
          document.getElementById("code_4").value +
          document.getElementById("code_5").value +
          document.getElementById("code_6").value,
      };
      console.log(payload);
      const response = await verifyCode(payload);
      console.log(response);
      if (response && !response.error) {
        dispatch(setAlert(translateMessage(response?.message || "Bad request")));
        navigate("/profile");
      } else {
        dispatch(setAlert(translateMessage(response?.message || "Bad request")));
      }
    };

    return (
      <>
        <div className="loginContainer">
          <div className="text-align-center" style={{ marginTop: "-50px" }}>
            <div className="titleLogin  mb-3">Verificar teléfono</div>
            <div className="formVerifyCode">
              <input id="code_1" type="text" onClick={getClipboardText} onInput={() => document.getElementById("code_2").focus()} />
              <input id="code_2" type="text" onInput={() => document.getElementById("code_3").focus()} />
              <input id="code_3" type="text" onInput={() => document.getElementById("code_4").focus()} />
              <input id="code_4" type="text" onInput={() => document.getElementById("code_5").focus()} />
              <input id="code_5" type="text" onInput={() => document.getElementById("code_6").focus()} />
              <input id="code_6" type="text" onInput={() => null} />
            </div>

            <Button text={"Verificar"} icon={null} customClass={"customButtonColor2  mt-3 mb-5"} action={verifyPhone} />
            <div className="registerInfo" style={{ marginTop: "15px" }}>
              <span
                role="button"
                tabIndex={0}
                onClick={sendCode}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    sendCode();
                  }
                }}
                style={{ cursor: "pointer" }}
              >
                ¿Aún no has recibido el sms? <b>Reenviar sms</b>
              </span>
            </div>
          </div>
        </div>
      </>
    );
  };

  const PhoneArea = () => {
    return (
      <>
        <div className="loginContainer">
          <div className="text-align-center" style={{ marginTop: "-50px" }}>
            <div className="titleLogin  mb-5">Verificar teléfono</div>

            <Input
              id={"name"}
              type={"text"}
              label={"Escriba su teléfono para verificarlo"}
              validation={"telefono"}
              placeholder="Escriba su teléfono"
              disabled={""}
              onKeyPress={() => null}
              icon={null}
              iconType={""}
              classname={""}
              defaultValue={""}
            />

            <Button text={"Enviar"} icon={null} customClass={"customButtonColor2  mt-3 mb-5"} action={sendCode} />
          </div>
        </div>
      </>
    );
  };

  useEffect(() => {
    !logged && navigate("/login");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="loginArea">
      <div className="topSide">
        {/*<div className="logoContainer">
          <img src={Logo} alt="logo" className="logoLogin" onClick={goToHome} />
        </div>*/}
        <div className="formContainer">{mode === "phone" ? <PhoneArea /> : <CodeArea />}</div>
      </div>
    </div>
  );
};
